import React from 'react';
import PropTypes from 'prop-types';
import styles from './PanelInfo.module.scss';
import {CheckIcon} from "./CheckIcon";

export const PanelInfo = (props) => {
  const {title, description} = props;

  return (
    <div className={styles.container}>
      <h1>
        <CheckIcon/>
        <span>{title}</span>
      </h1>
      <p>{description}</p>
    </div>
  );
};

PanelInfo.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string
}

PanelInfo.defaultProps = {}

export default React.memo(PanelInfo);